/* eslint-disable react-hooks/exhaustive-deps */
import useFetch from '@hooks/useFetch';
import { useRouter } from 'next/router';

/**
 *
 * @param { String } username - Username of the profile to be fetched
 * @param { Object } options
 * @param {Function | null | undefined} options.selector - Selects a value from the profile data
 * @param {Object | null | undefined} options.fallbackData - Data to fallback on
 * @param {String | null | undefined} options.goalUid - Goal based profile for educator levels
 * @returns {Object | SelectedValue}
 */
const useProfile = (
  username,
  options = {
    selector: null,
    fallbackData: undefined,
    goalUid: '',
    revalidateOnMount: false
  }
) => {
  const router = useRouter();

  const isLearner = router.pathname?.includes('/learner/');
  const learnerParams = options.goalUid ? `?goal_uid=${options.goalUid}` : '';
  const key = isLearner
    ? `v1/user/${username}/info/${learnerParams}`
    : `sheldon/v1/user/info?username=${username?.toLowerCase()}`;
  const {
    data: profileData,
    isValidating,
    ...rest
  } = useFetch(
    key,
    {},
    {
      fallbackData: options.fallbackData,
      revalidateOnMount: options.revalidateOnMount
    }
  );

  if (options.selector && typeof options.selector === 'function')
    return options.selector(profileData || {});
  return {
    key,
    profileData,
    isValidating,
    ...rest
  };
};

export default useProfile;
